import { useEffect, useState } from 'react'
import { customerData } from '../../../utilities/CustomerData'
import { addDays } from 'date-fns'
import { DateTime } from 'luxon'

export default function DashboardFilingTimer() {
  const [filingTimer, setFilingTimer] = useState({
    days: '00',
    hours: '00',
    minutes: '00',
    seconds: '00',
  })

  useEffect(() => {
    const hasExtension = customerData.customerDocuments.hasExtension
    const filingDate = (customerData.customerLeadData.leadContact.filingDate ? customerData.customerLeadData.leadContact.filingDate : customerData.customerDocuments.filingDate) || '2022-04-18'
  
    let [year, month, day] = ['2022', '04', '18']
    if (/^\d{4}-\d{2}-\d{2}$/.test(filingDate))
      [year, month, day] = filingDate.split('-')
  
    const timerMonth = month
    const timerDay = day
  
    const currentYear = DateTime.now().setZone('America/New_York').year
    const rawTargetDate = DateTime.fromObject(
      {
        year: currentYear,
        month: parseInt(timerMonth),
        day: parseInt(timerDay),
        hour: 23,
        minute: 59,
        second: 59,
      },
      { zone: 'America/New_York' }
    ).toMillis()
  
    const maxDate = DateTime.fromISO('2025-10-15T23:59:59', { zone: 'America/New_York' }).toMillis()
    let targetDate = year !== '2022' ? maxDate : Math.min(rawTargetDate, maxDate)
  
    if (customerData.customerLeadData.leadStage.leadStageName.startsWith('AF') && customerData.customerLeadData.leadStage.leadStageId !== 'f96797f5-64bd-443a-ad49-dc0abed71e07') {
      const offsetDays = hasExtension ? 1 : 0
      const adjustedTargetDate = DateTime.fromMillis(targetDate, { zone: 'America/New_York' }).minus({ days: offsetDays })
      targetDate = adjustedTargetDate.toMillis()
    }
  
    const updateCountdown = () => {
      const now = DateTime.now().setZone('America/New_York').toMillis()
      const difference = targetDate - now
  
      if (difference <= 0) {
        setFilingTimer({ days: '00', hours: '00', minutes: '00', seconds: '00' })
        return
      }
  
      const days = Math.floor(difference / (1000 * 60 * 60 * 24))
      const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60))
      const seconds = Math.floor((difference % (1000 * 60)) / 1000)
  
      setFilingTimer({
        days: String(days).padStart(2, '0'),
        hours: String(hours).padStart(2, '0'),
        minutes: String(minutes).padStart(2, '0'),
        seconds: String(seconds).padStart(2, '0'),
      })
    }
  
    updateCountdown()
    const interval = setInterval(updateCountdown, 1000)
    return () => clearInterval(interval)
  }, [customerData.customerDocuments.hasExtension])

  return (
    <div className='w-full max-sm:w-11/12 flex flex-col items-center gap-4 bg-white rounded-lg shadow-lg mt-4 p-4'>
      <p className='font-bold text-[#646464] text-2xl'>IRS Filing Deadline</p>
      <div className='flex flex-row items-center gap-10 max-sm:gap-4'>
        <div className='flex flex-col items-center'>
          <p className='font-bold text-red-600 text-4xl'>{filingTimer.days}</p>
          <p className='font-bold text-red-600'>Days</p>
        </div>
        <div className='flex flex-col items-center'>
          <p className='font-bold text-red-600 text-4xl'>{filingTimer.hours}</p>
          <p className='font-bold text-red-600'>Hours</p>
        </div>
        <div className='flex flex-col items-center'>
          <p className='font-bold text-red-600 text-4xl'>{filingTimer.minutes}</p>
          <p className='font-bold text-red-600'>Minutes</p>
        </div>
        <div className='flex flex-col items-center'>
          <p className='font-bold text-red-600 text-4xl'>{filingTimer.seconds}</p>
          <p className='font-bold text-red-600'>Seconds</p>
        </div>
      </div>
      <p className='font-bold text-[#646464] text-sm'>Until your SETC IRS Documents MUST be Mailed/Postmarked to the IRS</p>
    </div>
  )
}